import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { Message, MessageProps } from 'semantic-ui-react'

// Message that scrolls into view when rendered

export const FlashMessage = (props: MessageProps) => {
  const ref = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!ref.current) return
      ref.current.scrollIntoView()
    })
    return () => timeout && clearTimeout(timeout)
  }, [])
  return (
    <div ref={ref} style={{ padding: '12px 0' }}>
      <Message visible {...props} />
    </div>
  )
}

// Message that shows below header and scrolls page to top when rendered
export const GlobalFlashMessage = (props: MessageProps) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return createPortal(
    <div className="mt-small mb-small" style={{ textAlign: 'center' }}>
      <div style={{ display: 'inline-block' }}>
        <Message visible {...props} />
      </div>
    </div>,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    document.getElementById('global-flash-message')!
  )
}
